// Shared DealersLoader (cached globally)
if (!window.DealersLoader) {
  window.DealersLoader = {
    data: null,
    promise: null,

    async load() {
      if (this.data) return this.data;

      if (!this.promise) {
        this.promise = fetch(window.__dealersJsonUrl)
          .then(r => r.json())
          .then(json => {
            this.data = json;
            return json;
          })
          .catch(err => {
            console.error("Failed to load dealers.json", err);
            throw err;
          });
      }

      return this.promise;
    },
  };
}

// Prebook Popup Component
if (!window.customElements.get("prebook-popup-btn")) {
  class PrebookPopupBtn extends HTMLElement {
    constructor() {
      super();
      this._open = this._open.bind(this);
    }

    connectedCallback() {
      this.modal = document.getElementById("prebook-popup-modal");

      if (!this.modal) {
        console.error("Prebook modal not found in DOM");
        return;
      }

      if (!this.modal.dataset.initialized) {
        this._initModal();
        this.modal.dataset.initialized = "true";
      }

      this.addEventListener("click", this._open);
    }

    // INIT MODAL
    _initModal() {
      this.overlay = this.modal.querySelector(".popup-overlay");
      this.closeBtn = this.modal.querySelector(".popup-close-icon");
      this.form = this.modal.querySelector("form");

      this.stateSelect = this.form.querySelector("select[name='properties[State]']");
      this.citySelect = this.form.querySelector("select[name='properties[City]']");
      this.dealerSelect = this.form.querySelector("select[name='properties[Dealer]']");
      this.submitBtn = this.form.querySelector("button[type='submit']");
      this.alertBox = this.form.querySelector(".field-alert");

      // Close
      this.closeBtn.addEventListener("click", () => this._close());
      this.overlay.addEventListener("click", () => this._close());

      // Dropdowns
      this.stateSelect.addEventListener("change", () => this._handleStateChange());
      this.citySelect.addEventListener("change", () => this._handleCityChange());
      this.dealerSelect.addEventListener("change", () => this._handleDealerChange());

      // Prevent invalid clicks
      [this.citySelect, this.dealerSelect].forEach(select => {
        select.addEventListener("mousedown", (e) => {
          if (select.disabled) {
            e.preventDefault();
            this._showAlert("Please select the previous field first.");
          }
        });
      });

      this.form.addEventListener("submit", (e) => this._handleSubmit(e));

      this._loadDealers();
      this._reset();
    }

    // OPEN MODAL
    _open() {
      const card = this.closest(".product-card");

      let variantId = null;

      const checkedInput = card?.querySelector("input[type='radio']:checked");

      if (checkedInput) {
        variantId = checkedInput.dataset.variantId || checkedInput.value;
      }

      if (!variantId) {
        const hiddenInput = card?.querySelector("input[name='id']");
        if (hiddenInput) {
          variantId = hiddenInput.value;
        }
      }

      if (!variantId) {
        variantId = this.dataset.variantId;
      }

      if (!variantId) {
        console.error("❌ Variant ID not found");
        return;
      }

      const variantInput = this.modal.querySelector("input[name='id']");

      this._reset();
      variantInput.value = variantId;

      console.log("✅ FINAL VARIANT:", variantId);

      this.modal.classList.add("open");
    }

    // CLOSE MODAL
    _close() {
      this.modal.classList.remove("open");
      document.body.classList.remove("no-scroll");
      this._reset();
    }

    // RESET
    _reset() {
      const stateSelect = this.modal.querySelector("select[name='properties[State]']");
      const citySelect = this.modal.querySelector("select[name='properties[City]']");
      const dealerSelect = this.modal.querySelector("select[name='properties[Dealer]']");
      const submitBtn = this.modal.querySelector("button[type='submit']");
      const alertBox = this.modal.querySelector(".field-alert");

      stateSelect.value = "";
      citySelect.innerHTML = `<option value="">Select City</option>`;
      citySelect.disabled = true;

      dealerSelect.innerHTML = `<option value="">Select Dealer</option>`;
      dealerSelect.disabled = true;

      submitBtn.disabled = true;
      submitBtn.classList.remove("loading");

      if (alertBox) {
        alertBox.textContent = "";
        alertBox.style.display = "none";
      }

      [stateSelect, citySelect, dealerSelect].forEach(el =>
        el.classList.remove("valid-field")
      );
    }

    // LOAD DEALERS
    async _loadDealers() {
      try {
        this.dealers = await window.DealersLoader.load();

        if (this.stateSelect.options.length > 1) return;

        const states = [...new Set(this.dealers.map(d => d.state))];

        states.forEach(state => {
          const opt = document.createElement("option");
          opt.value = state;
          opt.textContent = state;
          this.stateSelect.appendChild(opt);
        });
      } catch (err) {
        console.error(err);
      }
    }

    _handleStateChange() {
      this.citySelect.innerHTML = `<option value="">Select City</option>`;
      this.citySelect.disabled = !this.stateSelect.value;

      this.dealerSelect.innerHTML = `<option value="">Select Dealer</option>`;
      this.dealerSelect.disabled = true;

      this.submitBtn.disabled = true;

      if (this.stateSelect.value) {
        const cities = [
          ...new Set(
            this.dealers
              .filter(d => d.state === this.stateSelect.value)
              .map(d => d.city)
          )
        ];

        cities.forEach(city => {
          const opt = document.createElement("option");
          opt.value = city;
          opt.textContent = city;
          this.citySelect.appendChild(opt);
        });
      }
    }

    _handleCityChange() {
      this.dealerSelect.innerHTML = `<option value="">Select Dealer</option>`;
      this.dealerSelect.disabled = !this.citySelect.value;

      this.submitBtn.disabled = true;

      if (this.citySelect.value) {
        const dealers = this.dealers.filter(
          d =>
            d.state === this.stateSelect.value &&
            d.city === this.citySelect.value
        );

        dealers.forEach(d => {
          const opt = document.createElement("option");
          opt.value = d.dealer;
          opt.textContent = d.dealer;
          this.dealerSelect.appendChild(opt);
        });
      }
    }

    _handleDealerChange() {
      this.submitBtn.disabled = !(
        this.stateSelect.value &&
        this.citySelect.value &&
        this.dealerSelect.value
      );
    }

    // SUBMIT
    async _handleSubmit(e) {
      e.preventDefault();

      if (this.submitBtn.disabled) {
        this._showAlert("Please complete all fields before proceeding.");
        return;
      }

      this.submitBtn.disabled = true;
      this.submitBtn.classList.add("loading");

      const formData = new FormData(this.form);

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });

        if (!response.ok) throw new Error("Cart add failed");

        setTimeout(() => {
          window.location.href = "/checkout";
        }, 300);

      } catch (err) {
        console.error(err);
        this._showAlert("Something went wrong. Please try again.");
        this.submitBtn.disabled = false;
        this.submitBtn.classList.remove("loading");
      }
    }

    _showAlert(msg) {
      if (this.alertBox) {
        this.alertBox.textContent = msg;
        this.alertBox.style.display = "block";
      }
    }
  }

  window.customElements.define("prebook-popup-btn", PrebookPopupBtn);
}